import { combineReducers } from "redux";
// import toastsReducer from '../app/toasts/reducer';
// import fetchReducer from '../app/fetch/reducer'
import realmsReducer from '../app/mandant/mandantReducer';
import usersReducer from "../app/user/userReducer";

import brokerReducer, {keycloakTokenReducer, theRealmReducer} from "../app/start/reducer";
import { siteColorReducer, searchValueReducer } from "./ui/reducer";
import { dialogsReducer } from "./dialogs/reducer";
import { treeReducer } from "./tree/reducer";
import { profileReducer } from "./profile/reducer";
import { projectReducer } from "./project/reducer";
import { dataReducer } from "./data/reducer";
import { attributeReducer } from "./attribute/reducer";
import { componentReducer } from "./component/reducer";

export default combineReducers({
  realms: realmsReducer,
  users: usersReducer,
  requestId: brokerReducer,
  theRealm: theRealmReducer,
  keycloakToken: keycloakTokenReducer,
  siteColor: siteColorReducer,
  searchValue: searchValueReducer,
  dialogs: dialogsReducer,
  tree: treeReducer,
  profile: profileReducer,
  project: projectReducer,
  data: dataReducer,
  attribute: attributeReducer,
  component: componentReducer,
});